import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import ResourceUtils from "@/utils/resource-utils";
import {ResourceType} from "@/store/place/types";
import {BasePanel} from "@/scenes.ui/base-panel";
import Container = Phaser.GameObjects.Container;
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {Amount} from "@/model/amount";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";
import SkillUtils from "@/utils/skill-utils";
import CU from "@/utils/c-u";

export class OverchargePanel extends BasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, amount: Amount, overcharge: number, improveCallback: () => unknown,
                container?: Container) {
        super(scene, canvas, x, y, container);
        this.setDepth(2001);

        const self = this;

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);

        const window = SpriteUtils.addImage(this.scene, 0, 15, Keys.UI_WINDOW_HORIZONTAL).setOrigin(0.5, 0.5);
        this.add(window);

        const xButton = SpriteUtils.addImage(this.scene, 262, -228, Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5);
        this.add(xButton);

        xButton.setInteractive().on('pointerup', function() {
            self.close();
        });

        const title = TextUtils.addTextByFamily(this.scene, Tr('nedostatochno.resursov').toUpperCase(), 0, -198, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let lackText = TextUtils.addTextAdvanced(scene, Tr('ne.hvataet'), 0, -106,
            '#ffdddd', 18, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let effectText = TextUtils.addTextByFamily(scene, Tr('doplatit.izumrudami'),
            0, 0, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let resources: Map<ResourceType, number> = ResourceUtils.convert(amount);

        let itemY = -70;
        for (let [resType, resValue] of resources) {
            let existingValue = PlayerStore.getResourceValue(resType);
            if (existingValue < resValue) {
                let ri: RequiredItem = new RequiredItem(scene, canvas, 0, itemY,
                    ResourceUtils.getResourceImageId(resType), SkillUtils.formatMoreThanMillion(resValue - existingValue));
                this.add(ri);
                itemY += 40;
            }
        }

        let improveButton = new SquareButton(this.scene, 0, 130, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, Tr('doplatit'), false);

        improveButton.setCallback(() => {
            if (this.isOnTop()) {
                improveCallback();
            }
        });
        let overchargePriceText = TextUtils.addText(scene,
            SkillUtils.formatMoreThanMillion(overcharge), 0, 170, '#ffffff', 25, 'bold', 200);

        this.add([window, xButton, title, lackText, effectText, improveButton, overchargePriceText]);
    }

}

class RequiredItem extends Phaser.GameObjects.Container {
    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, iconKey: string, name: string) {
        super(scene);
        this.x = x * CU.S;
        this.y = y * CU.S;

        let valueText = TextUtils.addTextAdvancedNoWidth(scene, name, 12, 0,
            '#ffdddd', 19, 'normal', 100, 'center', 2, Fonts.ARIAL_MT);
        this.add(valueText);

        let icon = SpriteUtils.addSprite(this.scene, valueText.getLeftCenter().x! / CU.S - 24, 0, iconKey);
        SpriteUtils.setDispSize(icon, 44, 44);

        this.add(icon);
    }

}
